import { buildUrl, buildHeaders, buildRequest, fetchRequest } from '../utils/apis/RestApi';
import { handleError } from '../business/helpers';
import { type Brand, type ProductNature } from './dictionaries.type';

const base_path = 'dictionary';

export const getAvailableBrands = (): Promise<Brand[]> => {
  const headers = buildHeaders(true);
  const url = buildUrl('ICARE_BACK', `${base_path}/brands`);
  const request = buildRequest(url, 'GET', headers);

  return fetchRequest(request)
    .then(response => response.json())
    .catch(() => handleError('Dictionaries Request - GET brands'));
};

export const getProductNatureLabelsByIds = (productNatureIds: number[]): Promise<ProductNature[]> => {
  if (!productNatureIds?.length) {
    return Promise.resolve([]);
  }

  const headers = buildHeaders(true);
  const url = buildUrl('ICARE_BACK', `${base_path}/product_nature_label/${productNatureIds}`);
  const request = buildRequest(url, 'GET', headers);

  return fetchRequest(request).then(response => response.json());
};
